import APIClient from '@/shared/http/clients/api'

const resourceName = 'campanha'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=dataCriacao,desc&size=500`, data, config)
const GetAllSortedByNome = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nome,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=dataCriacao,desc&page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Start = (id = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/start/${id}`, config)
const Stop = (id = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/stop/${id}`, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}sort=dataCriacao,desc&page=${index}&size=${limit}`, config)
const SendTest = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/envio-teste/`, data, config)

const CampaignRepository = {
  GetAll,
  GetAllSortedByNome,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  SendTest,
  Start,
  Stop
}

export default CampaignRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/campaign/campaign.js